module.exports = __webpack_public_path__ + "img/product_2.370e19a2.jpg";